import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { Pause } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { FlowStatus } from '@/services/dynamicFlowsService';

const STYLES: Record<FlowStatus, string> = {
  published: 'bg-[#DCFCE7] text-[#15803D]',
  draft: 'bg-[#F3F4F6] text-[#374151] border border-dashed border-[#9CA3AF]',
  paused: 'bg-[#E2E8F0] text-[#334155]',
};

const LABELS: Record<FlowStatus, string> = {
  published: 'Publicado',
  draft: 'Rascunho',
  get paused() { return translateInterfaceText("Pausado"); },
};

interface FlowStatusBadgeProps {
  status: FlowStatus;
  version?: number | null;
  className?: string;
}

export function FlowStatusBadge({ status, version, className }: FlowStatusBadgeProps) {
  useLanguage();
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-semibold',
        STYLES[status],
        className,
      )}
    >
      {status === 'published' && <span className="h-1.5 w-1.5 rounded-full bg-[#15803D]" />}
      {status === 'paused' && <Pause className="h-3 w-3" strokeWidth={3} />}
      {LABELS[status]}
      {status === 'published' && version ? ` · v${version}` : null}
    </span>
  );
}

export function UnpublishedChangesBadge({ className }: { className?: string }) {
  useLanguage();
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full bg-[#FEF3C7] px-2.5 py-0.5 text-xs font-semibold text-[#92400E]',
        className,
      )}
    >
      {translateInterfaceText("Alterações não publicadas")}</span>
  );
}
